import { useState } from "react";

import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import { handleCreateErrors } from "../../../components/utils/errors"

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useGetUnlimitedListOf from "../../../hooks/useGetUnlimitedListOf";


const Create = ({ handleOpen, open }) => {
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();

  const table = "Promotion_Attachments";

  const [selectedpromotion_id, setSelectedpromotion_id] = useState(null);
  const [selectedfile_type_id, setSelectedfile_type_id] = useState(null);
  const promotionsTemp = useGetUnlimitedListOf("Promotions", "", "list");
  const promotionsData = promotionsTemp.listElements;

  const file_typesTemp = useGetUnlimitedListOf("File_Types", "", "list");
  const file_typesData = file_typesTemp.listElements;

  const columns = ["id", "promotion_id", "file_type_id", "path", "title"];

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const create = async (formData) => {
if (!formData.promotion_id?.trim() || formData.file_type_id === null || !formData.path?.trim()) {
    window.alert("promotion_id, file_type_id, path non possono essere vuoti!");
    return;
  }


	 const errors = {}
	 const apiCall = `/${table}/create`
    try {
      const response = await axiosPrivate.post(apiCall, formData);
      if (!response) throw new Error("Errore nella creazione");

      window.alert("Creazione avvenuta con successo")

    } catch (error) {
    errors.call = apiCall;
    errors.callData = formData;
    errors.error = error;
    errors.forceReload = false;

    handleCreateErrors(errors, true)

    }
  };

  return (
    <>
      <Modal open={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
          }}
          alignItems={"center"}
        >
          <Box display={"flex"} justifyContent={"space-between"} sx={{ mb: 2 }}>
            <Typography
              id="keep-mounted-modal-title"
              variant="h6"
              component="h2"
            >
              Crea un nuovo elemento per la tabella {table}
            </Typography>
            <Button
              color="error"
              onClick={() => handleOpen(false, "create")}
              sx={{
                maxWidth: "30px",
                maxHeight: "30px",
                minWidth: "30px",
                minHeight: "30px",
              }}
            >
              <CloseIcon />
            </Button>
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            sx={{ width: "100%" }}
          >
            {/* Autocomplete per il campo promotion_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={promotionsData}
              getOptionLabel={(option) => option.id}
              value={
                selectedpromotion_id
                  ? promotionsData.find((promotion) => promotion.id === selectedpromotion_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedpromotion_id(newValue.id);
                  setValue("promotion_id", newValue.id);
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select promotion_id"
                  placeholder="promotion_id"
                  error={!!errors.promotion_id}
                  helperText={
                    errors.promotion_id ? "Il campo promotion_id è obbligatorio" : ""
                  }
                />
              )}
            />
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            sx={{ width: "100%" }}
          >
            {/* Autocomplete per il campo file_type_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={file_typesData}
              getOptionLabel={(option) => option.id}
              value={
                selectedfile_type_id
                  ? file_typesData.find((file) => file.id === selectedfile_type_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedfile_type_id(newValue.id);
                  setValue("file_type_id", newValue.id);
                }
              }}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select file_type_id"
                  placeholder="file_type_id"
                  error={!!errors.file_type_id}
                  helperText={
                    errors.file_type_id ? "Il campo file_type_id è obbligatorio" : ""
                  }
                />
              )}
            />
          </Box>

          {/* Altri campi */}
          {columns
            .filter((column) => column !=="id" && column !== "promotion_id" && column !== "file_type_id")
            .map((column, index) => (
              <TextField
                key={index}
                placeholder={column}
                sx={{ width: "50%", m: 1 }}
                {...register(column)}
              />
            ))}


          <Button onClick={handleSubmit(create)}>CREA ENTRY</Button>
        </Box>
      </Modal>
    </>
  );
};

export default Create;